import { Link } from 'react-router-dom';

import { Container } from '@sshop/ui';
import { useTranslation } from '@sshop/i18n';
import { useLocale } from '@/shared/hooks/useLocale';
import { routes } from '@/shared/lib/routes';

export function NotFoundPage() {
  const { t } = useTranslation();
  const locale = useLocale();
  return (
    <Container size="md" className="py-20 text-center">
      <p className="text-sm font-medium text-accent">404</p>
      <h1 className="mt-2 text-4xl font-semibold">{t('app.notFound')}</h1>
      <p className="mt-4 text-fg-secondary">{t('app.notFoundDetail')}</p>
      <Link to={routes.home(locale)} className="mt-6 inline-block text-accent hover:underline">
        {t('app.goHome')}
      </Link>
    </Container>
  );
}
